(function () {
  function updateCartAttributes() {
    window.theme.cart.getCart().then(res => {
      const reg = /(['"])?([a-z0-9A-Z_]+)(['"])?:(['"])?([\s*\w*.]+)(['"])?/g;
      const acciseTaxeHiddenInputs = document.querySelectorAll('[name="attributes[accise_tax]"]');
      const vignetteTaxHiddenInputs = document.querySelectorAll('[name="attributes[vignette_tax]"]');
      var acciseTaxesObject = [];
      var vignetTaxesObject = [];
      const map = res.items.reduce((acc, {sku, quantity}) => {
        acc[sku] = quantity + (acc[sku] || 0);
        return acc;
      }, {});
      const uniqueProducts = Object.entries(map).map(([key, value], index) => ({
        sku: key,
        quantity: value
      }));

      uniqueProducts.forEach(el =>{
        const QUANTITYFIELD = document.querySelector(`[data-sku="${el.sku}"]`);
        const acciseTaxVal = parseFloat(QUANTITYFIELD.getAttribute('data-accise-tax')) || 0;
        const vignetTaxVal = parseFloat(QUANTITYFIELD.getAttribute('data-vignette-tax')) || 0;
        const acciseTax = acciseTaxVal * el.quantity;
        const vignetTax = vignetTaxVal * el.quantity;

        acciseTaxesObject.push({"sku":el.sku, "value":acciseTax.toFixed(2)})
        vignetTaxesObject.push({"sku":el.sku, "value":vignetTax.toFixed(2)})

        const acciseTaxStringObject = JSON.stringify(acciseTaxesObject).replace(reg, '$2: $5').replace(/\s/g, '');
        const vignetteTaxStringObject = JSON.stringify(vignetTaxesObject).replace(reg, '$2: $5').replace(/\s/g, '');

        acciseTaxeHiddenInputs.forEach(acciseTaxHiddenInput => acciseTaxHiddenInput.value = acciseTaxStringObject)
        vignetteTaxHiddenInputs.forEach(acciseTaxHiddenInput => acciseTaxHiddenInput.value = vignetteTaxStringObject)
      })
    }).catch(err =>{
    });
  }
   document.addEventListener('update-cart-attributes', function() {
    updateCartAttributes(); 
  });
  document.addEventListener('cart:updated', function() {
    updateCartAttributes(); 
  });

  window.addEventListener('DOMContentLoaded', () => {
    updateCartAttributes();
  });
})();